import React from 'react';
import { Upload, Camera, StickyNote } from 'lucide-react';
import { SignOutButton } from '../SignOutButton';

interface HeaderProps {
  onUploadClick: () => void;
  currentView: 'photos' | 'notes';
  onViewChange: (view: 'photos' | 'notes') => void;
}

const Header: React.FC<HeaderProps> = ({ onUploadClick, currentView, onViewChange }) => {
  return (
    <header className="sticky top-0 z-30 bg-stone-100/80 backdrop-blur-sm border-b border-stone-200">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 sm:h-20">
          {/* Logo区域 - 移动端简化 */}
          <div className="flex items-center space-x-2 sm:space-x-3">
            <div className="w-8 h-8 sm:w-10 sm:h-10 bg-stone-800 rounded-full flex items-center justify-center text-stone-100">
              <span className="font-serif font-bold text-lg sm:text-xl">C</span>
            </div>
            <div className="flex flex-col">
              <h1 className="text-lg sm:text-xl font-serif text-stone-800 tracking-wider">楚生印象</h1>
              <span className="text-xs text-stone-500 tracking-widest uppercase hidden sm:block">Acoustic & Soul</span>
            </div>
          </div>

          {/* 导航菜单 - 移动端优化 */}
          <div className="flex items-center space-x-0.5 sm:space-x-1 bg-white rounded-full p-0.5 sm:p-1 shadow-sm border border-stone-200">
            <button
              onClick={() => onViewChange('photos')}
              className={`flex items-center space-x-1 sm:space-x-2 px-2 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm transition-all duration-200 ${
                currentView === 'photos'
                  ? 'bg-stone-800 text-white shadow-sm'
                  : 'text-stone-600 hover:text-stone-800 hover:bg-stone-50'
              }`}
            >
              <Camera size={14} className="sm:w-4 sm:h-4" />
              <span className="hidden xs:inline sm:inline">照片</span>
            </button>
            <button
              onClick={() => onViewChange('notes')}
              className={`flex items-center space-x-1 sm:space-x-2 px-2 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm transition-all duration-200 ${
                currentView === 'notes'
                  ? 'bg-stone-800 text-white shadow-sm'
                  : 'text-stone-600 hover:text-stone-800 hover:bg-stone-50'
              }`}
            >
              <StickyNote size={14} className="sm:w-4 sm:h-4" />
              <span className="hidden xs:inline sm:inline">便签</span>
            </button>
          </div>

          {/* 右侧按钮区域 - 移动端简化 */}
          <div className="flex items-center space-x-2 sm:space-x-4">
            <button 
              onClick={onUploadClick}
              className="flex items-center space-x-1 sm:space-x-2 px-2 sm:px-4 py-1.5 sm:py-2 bg-stone-800 text-stone-100 rounded-full text-xs sm:text-sm hover:bg-stone-700 transition duration-300 shadow-md active:scale-95"
            >
              <Upload size={14} className="sm:w-4 sm:h-4" />
              <span className="hidden sm:inline">上传回忆</span>
              <span className="sm:hidden">上传</span>
            </button>
            
            <div className="scale-90 sm:scale-100">
              <SignOutButton />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;